"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileExtEnum = void 0;
var FileExtEnum;
(function (FileExtEnum) {
    FileExtEnum["JPG"] = ".jpg";
    FileExtEnum["JPEG"] = ".jpeg";
    FileExtEnum["PNG"] = ".png";
    FileExtEnum["HEIC"] = ".heic";
    FileExtEnum["PDF"] = ".pdf";
    FileExtEnum["CSV"] = ".csv";
    FileExtEnum["XML"] = ".xml";
})(FileExtEnum || (exports.FileExtEnum = FileExtEnum = {}));
